import { ReactNode } from 'react';
import {
  makeSidebarConfig,
  makeSidebarSubmenuConfig,
  SidebarConfig,
  SidebarOptions,
  SubmenuConfig,
  SubmenuOptions,
  WbSidebarConfigContext,
} from './config';
import { WbDesktopSidebar } from './components/WbDesktopSidebar/WbDesktopSidebar';
import { WbMobileNavbar } from './components/WbMobileNavbar/WbMobileNavbar';
import { WbNavbarMobileStateProvider } from './WbNavbarMobileStateContext';
import { useResponsiveMobile } from './useResponsiveMobile';

/** @public */
export type SidebarClassKey = 'drawer' | 'drawerOpen';

/** @public */
export type SidebarProps = {
  openDelayMs?: number;
  closeDelayMs?: number;
  sidebarOptions?: SidebarOptions;
  submenuOptions?: SubmenuOptions;
  disableExpandOnHover?: boolean;
  children: ReactNode;
};

export const WbSidebar = (props: SidebarProps) => {
  const sidebarConfig: SidebarConfig = makeSidebarConfig(
    props.sidebarOptions ?? {},
  );
  const submenuConfig: SubmenuConfig = makeSidebarSubmenuConfig(
    props.submenuOptions ?? {},
  );

  const { disableExpandOnHover, openDelayMs, closeDelayMs, children } = props;

  const isMobile = useResponsiveMobile();

  return (
    <WbSidebarConfigContext.Provider
      value={{
        sidebarConfig,
        submenuConfig,
      }}
    >
      <WbNavbarMobileStateProvider
        value={{
          isMobile,
        }}
      >
        {isMobile ? (
          <WbMobileNavbar children={children} />
        ) : (
          <WbDesktopSidebar
            openDelayMs={openDelayMs}
            closeDelayMs={closeDelayMs}
            disableExpandOnHover={disableExpandOnHover}
            children={children}
          />
        )}
      </WbNavbarMobileStateProvider>
    </WbSidebarConfigContext.Provider>
  );
};
